import { FC } from 'react';
import LoveMatter from '../../../../../PageResultat/ResultatStudy/LoveMatter';
import StudyStyle from '../../../../../PageResultat/ResultatStudy/StudyStyle';
import { MajorTestContentProps } from '../types';
import { useMajorResultStyles } from '../MajorResult.styles';

const StudyContent: FC<MajorTestContentProps> = ({ myResult }) => {
  const classes = useMajorResultStyles();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
      {myResult?.studyStyle && (
        <section>
          <h2 className={classes.detailsSectionTitle}>
            Ton Study® Style est {myResult.studyStyle.favorite?.label}
          </h2>
          <StudyStyle data={myResult.studyStyle} />
        </section>
      )}
      {myResult?.loveMatter && (
        <section>
          <h2 className={classes.detailsSectionTitle}>
            Ta love matière ❤️ est {myResult.loveMatter.favorite?.label}
          </h2>
          <LoveMatter data={myResult.loveMatter} />
        </section>
      )}
    </div>
  );
};

export default StudyContent;
